
import {ActionTypes, CCAuthorizedAxios, CCAxios, DataActionTypes} from './../../cc-imports'

const Actions = {

    getLeague: (leagueId, authDetails, type) => {
        return {
            type: ActionTypes.GET_LEAGUE,
            payload: CCAuthorizedAxios(authDetails).get('/league/leagueId/' + leagueId + '/'),
            meta: {
                type: type
            }
        }
    },

    refreshLeague: (leagueId, authDetails, type) => {
        return {
            type: ActionTypes.REFRESH_LEAGUE,
            payload: CCAuthorizedAxios(authDetails).get('/league/leagueId/' + leagueId + '/'),
            meta: {
                type: type
            }
        }
    },

    getLiveLeagues: (req, authDetails, type) => {
        return {
            type: ActionTypes.GET_LEAGUES,
            payload: CCAuthorizedAxios(authDetails).get('/league/live/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
            meta: {
                type: type
            }
        }
    },
    getSponsoredLeagues: (authDetails, type) => {
        return {
            type: ActionTypes.GET_LEAGUES,
            payload: CCAuthorizedAxios({accessToken: authDetails.idToken}).get('/league/sponsored/userId/' + authDetails.userId + '/'),
            meta: {
                type: type
            }
        }
    },
    getUpcomingLeagues: (req, authDetails, type) => {
        return {
            type: ActionTypes.GET_LEAGUES,
            payload: CCAuthorizedAxios(authDetails).get('/league/upcoming/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
            meta: {
                type: type
            }
        }
    },
    getRecentLeagues: (req, authDetails, type) => {
        return {
            type: ActionTypes.GET_LEAGUES,
            payload: CCAuthorizedAxios(authDetails).get('/league/recent/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
            meta: {
                type: type
            }
        }
    },
    getLeaguesByMatchId: (accessToken, matchId, userId, skip, limit, type) => {
        return {
            type: ActionTypes.GET_LEAGUES,
            payload: CCAuthorizedAxios({accessToken}).get('/league/matchId/' + matchId + '/userId/' + userId + '/' + skip + '/' + limit + '/'),
            meta: {
                type: type,
                id: matchId
            }
        }
    },

    /*getLeaguesByMatchId: (req, authDetails, type) => {
        return {
            type: ActionTypes.GET_LEAGUES,
            payload: CCAuthorizedAxios(authDetails).get('/league/matchId/' + req.matchId + '/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
            meta: {
                type: type
            }
        }
    },*/

    getLeagues: (type, userId, skip, limit, accessToken, actionType) => {
        switch (type) {
            case 'PREDICTION':
                return {
                    type: ActionTypes.GET_LEAGUES,
                    payload: CCAuthorizedAxios({accessToken}).get('/league/upcoming/category/prediction/userId/' + userId + '/' + skip + '/' + limit + '/'),
                    meta: {
                        type: actionType
                    }
                }
                break;
            case 'LIVE_PREDICTION':
                return {
                    type: ActionTypes.GET_LEAGUES,
                    payload: CCAuthorizedAxios({accessToken}).get('/league/upcoming/category/live_prediction/userId/' + userId + '/' + skip + '/' + limit + '/'),
                    meta: {
                        type: actionType
                    }
                }
                break;
            case 'DREAM_TEAM':
                return {
                    type: ActionTypes.GET_LEAGUES,
                    payload: CCAuthorizedAxios({accessToken}).get('/league/upcoming/category/dreamteam/userId/' + userId + '/' + skip + '/' + limit + '/'),
                    meta: {
                        type: actionType
                    }
                }
                break;
            default :
                return {
                    type: ActionTypes.GET_LEAGUES,
                    payload: CCAuthorizedAxios({accessToken}).get('/league/userId/' + userId + '/' + skip + '/' + limit + '/'),
                    meta: {
                        type: actionType
                    }
                }
        }
    },


    paginateLeagues: (req, authDetails, type) => {
        return {
            type: ActionTypes.PAGINATE_LEAGUES,
            payload: CCAuthorizedAxios(authDetails).get('/league/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
            meta: {
                type: type
            }
        }
    },

    refreshLeagues: (req, authDetails, type) => {
        return {
            type: ActionTypes.REFRESH_LEAGUE,
            payload: CCAuthorizedAxios(authDetails).get('/league/userId/' + authDetails.userId + '/' + req.skip + '/' + req.limit + '/'),
            meta: {
                type: type
            }
        }
    }
};

export default Actions



// WEBPACK FOOTER //
// ./src/app/data/actions/LeagueActions.js